// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1wDLc","search":"Settings_search__12X2-","filter":"Settings_filter__1G_QG"};